import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    Space,
    Typography,
    Divider,
    Tag,
    Table,
    Empty,
    Form,
    Modal,
    Input,
    Statistic,
    message,
    Select,
    Badge,
    Tooltip,
    Alert
} from "antd";

import {
    MergeCellsOutlined,
    ReloadOutlined,
    SaveOutlined,
    CheckOutlined,
    LinkOutlined,
    PlusOutlined,
    ApartmentOutlined,
    UnorderedListOutlined,
    TagOutlined,
    DatabaseOutlined
} from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";

import SearchListAutoComplete from "../../../components/SearchListAutoComplete";

import {
    fetchPurchaseVouchers,
    fetchAvailableSSCCCodes,
    createCSSSCC,
    removeAggregation,
    createAggregation,
    fetchPurchaseSSCCs,
    unpackSSCC,
    fetchUnpackStatus
} from "./aggregationThunk";

import {
    setSelectedPurchaseId,
    setSelectedPurchase,
    setMasterSSCC,
    setBeSSCCs,
    setCsSSCCs,
    clearSelectedSSCCs,
    setLoading,
    setAggregations,
    setHierarchyTree,
    setSelectedUnpackSSCC,
    setUnlinkedSSCCs,
    setUnpackSSCCList,
    setError
} from "./aggregationSlice";
import SSCCHierarchyTree from "./SSCCHierarchyTree";
import SSCCUnpacking
    from "./SSCCUnpacking";
import Swal from "sweetalert2";

const { Title, Text } = Typography;

const SSCCAggregation = () => {
    const dispatch = useDispatch();

    const {
        purchaseVouchers,
        selectedPurchaseId,
        selectedPurchase,
        masterSSCC,
        beSSCCs,
        csSSCCs,
        aggregations,
        hierarchyTree,
        unlinkedSSCCs,
        unpackSSCCList,
        selectedUnpackSSCC,
        unpackInProgress,
        loading
    } = useSelector(
        (state) => state.ssccAggregation
    );

    const [createCSModalOpen, setCreateCSModalOpen] = useState(false);
    const [newCSCode, setNewCSCode] = useState("");
    const [selectedParent, setSelectedParent] = useState(null);
    const [selectedChild, setSelectedChild] = useState(null);

    useEffect(() => {
        dispatch(
            fetchPurchaseVouchers({
                searchTerm: ""
            })
        );
    }, []);

    useEffect(() => {
        if (selectedPurchaseId) {
            loadSSCCData(selectedPurchaseId);
        }
    }, [selectedPurchaseId]);

    const loadSSCCData = async (
        purchaseId
    ) => {
        dispatch(setLoading(true));

        try {
            const data = await dispatch(
                fetchAvailableSSCCCodes(
                    purchaseId
                )
            ).unwrap();

            dispatch(
                setMasterSSCC(
                    data.masterSSCC || []
                )
            );

            dispatch(
                setBeSSCCs(
                    data.beSSCCs || []
                )
            );

            dispatch(
                setCsSSCCs(
                    data.csSSCCs || []
                )
            );

            dispatch(
                setAggregations(
                    data.aggregations || []
                )
            );

            dispatch(
                setHierarchyTree(
                    data.hierarchyTree || []
                )
            );

            dispatch(
                setUnlinkedSSCCs(
                    data.unlinkedSSCCs || []
                )
            );

            dispatch(
                setUnlinkedSSCCs(
                    data.unlinkedSSCCs || []
                )
            );

            try {

                const unpackData =
                    await dispatch(
                        fetchUnpackStatus(
                            purchaseId
                        )
                    ).unwrap();

                dispatch(
                    setUnpackSSCCList(
                        unpackData
                    )
                );

            } catch (err) {

                console.log(
                    "Failed to load unpack status",
                    err
                );

            }

            const totalSSCCs =
                (data.masterSSCC?.length || 0) +
                (data.beSSCCs?.length || 0) +
                (data.csSSCCs?.length || 0);

            message.success(
                `Loaded ${totalSSCCs} SSCCs`
            );

            dispatch(setError(null));
        } catch (err) {
            dispatch(
                setError(
                    err?.message ||
                    "Failed to load SSCCs"
                )
            );

            message.error(
                err?.message ||
                "Failed to load SSCCs"
            );
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleCreateCSSSCC =
        async () => {
            if (!newCSCode.trim()) {
                message.error(
                    "Enter SSCC code"
                );
                return;
            }

            try {
                await dispatch(
                    createCSSSCC({
                        purchaseId:
                            selectedPurchaseId,
                        ssccCode: newCSCode
                    })
                ).unwrap();

                message.success(
                    "CS SSCC Created"
                );

                setCreateCSModalOpen(false);
                setNewCSCode("");

                loadSSCCData(
                    selectedPurchaseId
                );
            } catch (err) {
                message.error(
                    err ||
                    "Failed to create CS SSCC"
                );
            }
        };

    const totalSSCCs =
        (masterSSCC?.length || 0) +
        (beSSCCs?.length || 0) +
        (csSSCCs?.length || 0);

    const allSSCCOptions = [
        ...(masterSSCC || []),

        ...(csSSCCs || []),

        ...(beSSCCs || [])
    ];

    const unpackableSSCCs = [
        ...(masterSSCC || [])
    ].filter(item =>

        item.unpack_status !==
        "sent"

        &&

        item.unpack_status !==
        "pending"
    );

    // const unpackableSSCCs = [
    //     ...(masterSSCC || []),
    //     ...(csSSCCs || []),
    //     ...(beSSCCs || [])
    // ].filter(item =>

    //     item.unpack_status !==
    //     "sent"

    //     &&

    //     item.unpack_status !==
    //     "pending"
    // );

    const handleUnpack =
        async () => {

            if (
                !selectedUnpackSSCC
            ) {
                return;
            }

            const selected =
                unpackableSSCCs.find(
                    x =>
                        x.id ===
                        selectedUnpackSSCC
                );

            if (!selected) {
                return;
            }

            try {

                await dispatch(
                    unpackSSCC({
                        purchaseId:
                            selectedPurchaseId,

                        ssccId:
                            selected.id,

                        ssccCode:
                            selected.sscc_code
                    })
                ).unwrap();

                Swal.fire({
                    icon: "success",
                    title:
                        "Unpack Started"
                });

                const unpackData =
                    await dispatch(
                        fetchUnpackStatus(
                            selectedPurchaseId
                        )
                    ).unwrap();

                dispatch(
                    setUnpackSSCCList(
                        unpackData
                    )
                );

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: err
                });

            }

        };

    const handleRemoveLink = (
        parentId,
        childId
    ) => {

        Swal.fire({
            title: "Remove Hierarchy?",
            text: "This relationship will be removed.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Remove",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33"
        }).then(async (result) => {

            if (!result.isConfirmed) {
                return;
            }

            try {

                await dispatch(
                    removeAggregation({
                        parentId,
                        childId
                    })
                ).unwrap();

                Swal.fire({
                    icon: "success",
                    title: "Removed",
                    text: "Hierarchy link removed successfully",
                    timer: 1500,
                    showConfirmButton: false
                });

                dispatch(
                    fetchPurchaseSSCCs(
                        selectedPurchaseId
                    )
                );

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Failed",
                    text: err || "Failed to remove hierarchy"
                });

            }

        });

    };

    const handleCreateLink = async () => {

        if (!selectedParent) {
            message.error(
                "Select Parent SSCC"
            );
            return;
        }

        if (!selectedChild) {
            message.error(
                "Select Child SSCC"
            );
            return;
        }

        if (
            selectedParent ===
            selectedChild
        ) {
            message.error(
                "Parent and Child cannot be same"
            );
            return;
        }

        try {

            await dispatch(
                createAggregation({
                    parentId:
                        selectedParent,
                    childId:
                        selectedChild
                })
            ).unwrap();

            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Hierarchy created successfully",
                timer: 1500,
                showConfirmButton: false
            });

            setSelectedParent(null);
            setSelectedChild(null);

            loadSSCCData(
                selectedPurchaseId
            );

        } catch (err) {

            message.error(
                err ||
                "Failed to create hierarchy"
            );

        }
    };

    // Helper function to render SSCC tags with count
    const renderSSCCList = (items, color, label) => (
        <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <Text strong style={{ fontSize: '14px' }}>{label}</Text>
                <Badge count={items?.length || 0} style={{ backgroundColor: color }} />
            </div>
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
                maxHeight: '120px',
                overflowY: 'auto',
                padding: '4px 0'
            }}>
                {(items || []).map(
                    (item) => (
                        <Tag
                            color={color}
                            key={item.id}
                            style={{
                                fontSize: '12px',
                                padding: '4px 12px',
                                borderRadius: '12px',
                                margin: 0
                            }}
                        >
                            {item.sscc_code}
                        </Tag>
                    )
                )}
                {(!items || items.length === 0) && (
                    <Text type="secondary" style={{ fontSize: '12px' }}>No SSCCs available</Text>
                )}
            </div>
        </div>
    );

    return (
        <div style={{ padding: '24px', background: '#f0f2f5', minHeight: '100vh' }}>
            <Row gutter={[16, 16]}>
                {/* Header */}
                <Col span={24}>
                    <Card
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <MergeCellsOutlined style={{ color: '#1890ff' }} />
                                    SSCC Aggregation
                                </Title>
                                <Text type="secondary" style={{ marginTop: '8px', display: 'block' }}>
                                    Manage SSCC hierarchies and aggregations for purchase vouchers
                                </Text>
                            </div>
                            {selectedPurchaseId && (
                                <Button
                                    icon={<ReloadOutlined />}
                                    onClick={() => loadSSCCData(selectedPurchaseId)}
                                    loading={loading}
                                >
                                    Refresh Data
                                </Button>
                            )}
                        </div>
                    </Card>
                </Col>

                {/* Purchase Voucher Selection */}
                <Col xs={24} lg={16}>
                    <Card
                        title={
                            <Space>
                                <DatabaseOutlined />
                                <span>Purchase Voucher</span>
                            </Space>
                        }
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            height: '100%'
                        }}
                    >
                        <Form.Item
                            label="Select Voucher"
                            required
                            style={{ marginBottom: 0 }}
                        >
                            <SearchListAutoComplete
                                placeholder="Search and select a purchase voucher..."
                                optionsList={(
                                    purchaseVouchers ||
                                    []
                                ).map((voucher) => ({
                                    value:
                                        voucher.pur_id,
                                    display_text:
                                        voucher.pur_voucher_no,
                                    raw: voucher
                                }))}
                                onSearch={(value) =>
                                    dispatch(
                                        fetchPurchaseVouchers(
                                            {
                                                searchTerm:
                                                    value
                                            }
                                        )
                                    )
                                }
                                onSelect={(obj) => {
                                    if (
                                        !obj?.raw
                                    )
                                        return;

                                    dispatch(
                                        setSelectedPurchaseId(
                                            obj.raw.pur_id
                                        )
                                    );

                                    dispatch(
                                        setSelectedPurchase(
                                            obj.raw
                                        )
                                    );

                                    dispatch(
                                        clearSelectedSSCCs()
                                    );
                                }}
                            />
                        </Form.Item>
                        {selectedPurchase && (
                            <Alert
                                message={`Selected: ${selectedPurchase.pur_voucher_no}`}
                                type="success"
                                showIcon
                                style={{ marginTop: '12px' }}
                            />
                        )}
                    </Card>
                </Col>

                {/* Available SSCCs */}
                <Col xs={24} lg={8}>
                    <Card
                        title={
                            <Space>
                                <UnorderedListOutlined />
                                <span>Available SSCCs</span>
                            </Space>
                        }
                        extra={
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() =>
                                    setCreateCSModalOpen(true)
                                }
                                disabled={!selectedPurchaseId}
                                size="small"
                            >
                                Add CS SSCC
                            </Button>
                        }
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            height: '100%'
                        }}
                        bodyStyle={{ padding: '16px' }}
                    >
                        {!selectedPurchaseId ? (
                            <Empty
                                description="Select a purchase voucher first"
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                style={{ margin: '16px 0' }}
                            />
                        ) : (
                            <>
                                {renderSSCCList(masterSSCC, 'blue', 'Master SSCC')}
                                <Divider style={{ margin: '8px 0' }} />
                                {renderSSCCList(csSSCCs, 'purple', 'CS Level SSCCs')}
                                <Divider style={{ margin: '8px 0' }} />
                                {renderSSCCList(beSSCCs, 'green', 'BE Level SSCCs')}
                            </>
                        )}
                    </Card>
                </Col>

                {/* Statistics */}
                <Col span={24}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={6}>
                            <Card
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                }}
                            >
                                <Statistic
                                    title={<span style={{ color: 'rgba(255,255,255,0.9)' }}>Total SSCCs</span>}
                                    value={totalSSCCs}
                                    valueStyle={{ color: '#fff', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
                                }}
                            >
                                <Statistic
                                    title={<span style={{ color: 'rgba(255,255,255,0.9)' }}>Master</span>}
                                    value={masterSSCC?.length || 0}
                                    valueStyle={{ color: '#fff', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    background: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)'
                                }}
                            >
                                <Statistic
                                    title={<span style={{ color: 'rgba(255,255,255,0.9)' }}>CS Level</span>}
                                    value={csSSCCs?.length || 0}
                                    valueStyle={{ color: '#fff', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <Card
                                style={{
                                    borderRadius: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
                                }}
                            >
                                <Statistic
                                    title={<span style={{ color: 'rgba(255,255,255,0.9)' }}>BE Level</span>}
                                    value={beSSCCs?.length || 0}
                                    valueStyle={{ color: '#fff', fontWeight: 'bold' }}
                                />
                            </Card>
                        </Col>
                    </Row>
                </Col>

                {/* Hierarchy Builder */}
                <Col span={24}>
                    <Card
                        title={
                            <Space>
                                <ApartmentOutlined />
                                <span>Hierarchy Builder</span>
                            </Space>
                        }
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                    >
                        {!selectedPurchaseId ? (
                            <Empty
                                description="Select a purchase voucher to build hierarchy"
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                            />
                        ) : (
                            <>
                                <Row gutter={[16, 16]} align="bottom">
                                    <Col xs={24} md={10}>
                                        <Form.Item
                                            label="Parent SSCC"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                value={selectedParent}
                                                placeholder="Select parent SSCC"
                                                onChange={setSelectedParent}
                                                showSearch
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                            >
                                                {allSSCCOptions
                                                    .filter(
                                                        item =>
                                                            item.level !==
                                                            "BE"
                                                    )
                                                    .map(
                                                        item => (
                                                            <Select.Option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                <Space>
                                                                    <Tag color="blue">{item.sscc_code}</Tag>
                                                                    <Text type="secondary">({item.level})</Text>
                                                                </Space>
                                                            </Select.Option>
                                                        )
                                                    )}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={10}>
                                        <Form.Item
                                            label="Child SSCC"
                                            style={{ marginBottom: 0 }}
                                        >
                                            <Select
                                                value={selectedChild}
                                                placeholder="Select child SSCC"
                                                onChange={setSelectedChild}
                                                showSearch
                                                optionFilterProp="children"
                                                style={{ width: '100%' }}
                                            >
                                                {allSSCCOptions
                                                    .filter(
                                                        item =>
                                                            item.level !==
                                                            "SSCC"
                                                    )
                                                    .map(
                                                        item => (
                                                            <Select.Option
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                <Space>
                                                                    <Tag color="green">{item.sscc_code}</Tag>
                                                                    <Text type="secondary">({item.level})</Text>
                                                                </Space>
                                                            </Select.Option>
                                                        )
                                                    )}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} md={4}>
                                        <Button
                                            type="primary"
                                            block
                                            icon={<LinkOutlined />}
                                            onClick={handleCreateLink}
                                            disabled={!selectedParent || !selectedChild}
                                            style={{ height: '40px' }}
                                        >
                                            Create Link
                                        </Button>
                                    </Col>
                                </Row>

                                <Divider />

                                <SSCCHierarchyTree
                                    hierarchyTree={hierarchyTree}
                                    unlinkedSSCCs={unlinkedSSCCs}
                                />
                            </>
                        )}
                    </Card>
                </Col>

                {/* Connected Hierarchy Table */}
                <Col span={24}>
                    <Card
                        title={
                            <Space>
                                <TagOutlined />
                                <span>Connected Hierarchy</span>
                            </Space>
                        }
                        style={{
                            borderRadius: '12px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}
                        extra={
                            <Badge
                                count={aggregations?.length || 0}
                                showZero
                                style={{ backgroundColor: '#1890ff' }}
                            />
                        }

                    >
                        <Table
                            dataSource={aggregations || []}
                            rowKey="id"
                            pagination={false}
                            locale={{
                                emptyText: <Empty description="No hierarchies connected yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            }}
                        >
                            <Table.Column
                                title="Parent SSCC"
                                render={(row) => {
                                    const parent =
                                        allSSCCOptions.find(
                                            x =>
                                                x.id ===
                                                row.parent_sscc_id
                                        );
                                    return (
                                        <Tag color="blue" style={{ fontSize: '13px' }}>
                                            {parent?.sscc_code || "-"}
                                        </Tag>
                                    );
                                }}
                            />

                            <Table.Column
                                title="Child SSCC"
                                render={(row) => {
                                    const child =
                                        allSSCCOptions.find(
                                            x =>
                                                x.id ===
                                                row.child_sscc_id
                                        );
                                    return (
                                        <Tag color="green" style={{ fontSize: '13px' }}>
                                            {child?.sscc_code || "-"}
                                        </Tag>
                                    );
                                }}
                            />

                            <Table.Column
                                title="Action"
                                align="center"
                                render={(row) => (
                                    <Button
                                        danger
                                        size="small"
                                        icon={<LinkOutlined />}
                                        onClick={() =>
                                            handleRemoveLink(
                                                row.parent_sscc_id,
                                                row.child_sscc_id
                                            )
                                        }
                                    >
                                        Remove Link
                                    </Button>
                                )}
                            />
                        </Table>
                    </Card>
                </Col>

                <Col span={24}>
                    <SSCCUnpacking
                        unpackableSSCCs={unpackableSSCCs}
                        selectedSSCC={selectedUnpackSSCC}
                        onSelectSSCC={(value) =>
                            dispatch(setSelectedUnpackSSCC(value))
                        }
                        onUnpack={handleUnpack}
                        unpackStatusList={unpackSSCCList}
                        loading={unpackInProgress}
                        canUnpack={true}
                    />
                </Col>
            </Row>

            {/* Create CS SSCC Modal */}
            <Modal
                title={
                    <Space>
                        <PlusOutlined />
                        <span>Create CS SSCC</span>
                    </Space>
                }
                open={createCSModalOpen}
                onCancel={() => {
                    setCreateCSModalOpen(false);
                    setNewCSCode("");
                }}
                onOk={handleCreateCSSSCC}
                okText="Create"
                cancelText="Cancel"
                okButtonProps={{
                    icon: <CheckOutlined />,
                    style: { backgroundColor: '#52c41a', borderColor: '#52c41a' }
                }}
                style={{ top: 20 }}
            >
                <div style={{ padding: '16px 0' }}>
                    <Text type="secondary" style={{ display: 'block', marginBottom: '16px' }}>
                        Enter the SSCC code for the new CS level SSCC
                    </Text>
                    <Input
                        value={newCSCode}
                        onChange={(e) => setNewCSCode(e.target.value)}
                        placeholder="Enter supplier SSCC code"
                        size="large"
                        prefix={<TagOutlined style={{ color: 'rgba(0,0,0,0.25)' }} />}
                        onPressEnter={handleCreateCSSSCC}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default SSCCAggregation;